import { Link } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import { ArrowUpRight, ArrowDownLeft, Wallet, Receipt, Smartphone, Zap, Tv, Droplet } from 'lucide-react';

const PaymentsPage = () => {
  const quickActions = [
    { icon: ArrowUpRight, label: 'Send Money', path: '/send', color: 'bg-primary', desc: 'Transfer to anyone' },
    { icon: ArrowDownLeft, label: 'Receive', path: '/receive', color: 'bg-green-500', desc: 'Get paid instantly' },
    { icon: Wallet, label: 'Withdraw', path: '/withdraw', color: 'bg-blue-500', desc: 'Cash out to bank' },
  ];

  const billCategories = [
    { icon: Smartphone, label: 'Airtime', color: 'bg-purple-500' },
    { icon: Zap, label: 'Data', color: 'bg-orange-500' },
    { icon: Receipt, label: 'Electricity', color: 'bg-yellow-500' },
    { icon: Tv, label: 'Cable TV', color: 'bg-pink-500' },
    { icon: Droplet, label: 'Water', color: 'bg-cyan-500' },
    { icon: Receipt, label: 'More', color: 'bg-gray-500' },
  ];

  return (
    <AppLayout>
      <div className="min-h-screen bg-background pb-24 lg:pb-0 lg:min-h-0">
        {/* Header */}
        <div className="p-6 lg:p-0 lg:mb-8">
          <h1 className="text-2xl font-bold lg:text-3xl" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Payments
          </h1>
          <p className="text-muted-foreground">Send, receive, and pay bills</p>
        </div>
        
        {/* Quick Actions */}
        <div className="px-6 pb-6 lg:px-0">
          <h2 className="text-lg font-semibold mb-4">Transfer Money</h2>
          <div className="grid grid-cols-3 gap-4">
            {quickActions.map(({ icon: Icon, label, path, color, desc }) => (
              <Link
                key={label}
                to={path}
                className="bg-card border border-white/10 rounded-xl p-4 lg:p-6 flex flex-col items-center gap-3 hover:border-primary/50 transition-colors"
                data-testid={`payment-${label.toLowerCase().replace(' ', '-')}`}
              >
                <div className={`w-12 h-12 lg:w-16 lg:h-16 rounded-full ${color} flex items-center justify-center`}>
                  <Icon className="w-6 h-6 lg:w-8 lg:h-8 text-white" />
                </div>
                <span className="text-sm font-medium text-center">{label}</span>
                <span className="hidden lg:block text-xs text-muted-foreground text-center">{desc}</span>
              </Link>
            ))}
          </div>
        </div>
        
        {/* Pay Bills */}
        <div className="px-6 pb-6 lg:px-0">
          <h2 className="text-lg font-semibold mb-4">Pay Bills</h2>
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-4">
            {billCategories.map(({ icon: Icon, label, color }) => (
              <button
                key={label}
                className="bg-card border border-white/10 rounded-xl p-4 flex flex-col items-center gap-3 hover:border-primary/50 transition-colors opacity-60"
                disabled
                data-testid={`bill-${label.toLowerCase()}`}
              >
                <div className={`w-12 h-12 rounded-full ${color}/20 flex items-center justify-center`}>
                  <Icon className={`w-6 h-6 ${color.replace('bg-', 'text-')}`} />
                </div>
                <span className="text-sm font-medium text-center">{label}</span>
              </button>
            ))}
          </div>
          <p className="text-xs text-muted-foreground text-center mt-4">
            Bill payments coming soon in Phase 2
          </p>
        </div>
      </div>
    </AppLayout>
  );
};

export default PaymentsPage;
